var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5867 6.91205C15.2612 6.58661 14.7336 6.58661 14.4081 6.91205L9.9974 11.3228L5.58665 6.91205C5.26121 6.58661 4.73358 6.58661 4.40814 6.91205C4.0827 7.23748 4.0827 7.76512 4.40814 8.09056L9.70277 13.3852C9.86549 13.5479 10.1293 13.5479 10.292 13.3852L15.5867 8.09056C15.9121 7.76512 15.9121 7.23748 15.5867 6.91205Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.fe17a7cf2589f8750836008b1ec18e2a.svg";
export { ForwardRef as ReactComponent };